module.exports = __webpack_public_path__ + "img/point_tab_redeem_coupon.ea1e36bb.svg";